import { Layout, MetaTag } from "src/components";
import { Card, Col, Row } from "antd";

import React from "react";
import BookForm from "../../../components/BookForm";

const EditView = (props: any) => {
    const { book, onFinish, onFinishFailed, disableSubjectClass } = props;

    return (
        <Layout
            titles={[
                { name: "Books", link: "/book" },
                { name: "Edit", link: "" },
                { name: book?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Book" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Book Update"}
                        bordered={true}
                    >
                        {book && (
                            <BookForm
                                book={book}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                disableSubjectClass={disableSubjectClass}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
